import { IAllocationDimension } from "helpers/allocation-dimension";
import { Validator } from "helpers/validator";
import {
    IAttributeData,
    IAttributeDataError,
    RuleType,
} from "../../../../components/product-collection/manage-allocation-dimension/import-door-attributes/types";
import { formatMessage } from "lib/globalize-util";
import { getDoorAttributeWithAllowedValuesWithBlankValue } from "helpers/door-collection";
import { buildColumnExpression } from "helpers/utils/build-column-expression";

export class AttributeIsFreeformRule extends Validator<IAttributeData[], IAttributeDataError> {
    noAttributesColumns: string[];
    allocationDimension: IAllocationDimension;

    constructor(noAttributesColumns: string[], allocationDimension: IAllocationDimension) {
        super();
        this.noAttributesColumns = noAttributesColumns;
        this.allocationDimension = allocationDimension;
    }

    validate(model: IAttributeData[], errors: IAttributeDataError): IAttributeDataError {
        let freeFormAttributes = [];
        if (!errors[RuleType.AttributeIsFreeformRule] && this.allocationDimension) {
            const headers = Object.keys(model[0] || {});

            freeFormAttributes = headers.reduce((acc, column) => {
                const expression = buildColumnExpression(column);

                if (
                    !this.noAttributesColumns.some((field) => expression.test(field)) &&
                    this.allocationDimension.attributes.keys.some((attribute) => {
                        const isReadonly = attribute.display?.read_only;
                        const isUserDefined = attribute.display?.is_user_defined;
                        const hasFreeformProperty = attribute.constraint?.hasOwnProperty("freeform");
                        const isFreeform = attribute.constraint?.freeform;
                        const allocationDimensionAttributesWithBlankValue =
                            getDoorAttributeWithAllowedValuesWithBlankValue({
                                allocationDimensionAttribute: attribute,
                                blankAtBeginning: true,
                            });

                        const allowedValuesFromAttribute =
                            allocationDimensionAttributesWithBlankValue.constraint?.allowed_values;

                        return (
                            !isUserDefined &&
                            !isReadonly &&
                            hasFreeformProperty &&
                            !isFreeform &&
                            !model.every((value) => {
                                return allowedValuesFromAttribute.some((allowed_value) => {
                                    const allowedValue = allowed_value?.string_value?.trim();
                                    const valueNormalized = value[attribute.display_name]?.trim();

                                    return allowedValue === valueNormalized;
                                });
                            }) &&
                            expression.test(attribute.display_name)
                        );
                    })
                ) {
                    acc.push(column);
                }

                return acc;
            }, []);
        }

        const validationErrors = freeFormAttributes.length
            ? {
                  ...errors,
                  [RuleType.AttributeIsFreeformRule]: formatMessage(
                      "|attributes|: This attribute does not allow custom values. Please review the door groupings table to view the list of allowed values.",
                      { attributes: freeFormAttributes.join(", ") }
                  ),
              }
            : errors;

        return super.validate(model, validationErrors);
    }
}
